import { FC, ReactNode } from 'react';

import { cn } from '@eluve/components';

const variantStyles = {
  error:
    'border-border-negative-subtle bg-bg-negative-subtle text-text-negative-subtle',
  success:
    'overflow-hidden border-border-positive bg-bg-positive-subtle text-text-positive',
  info: 'bg-bg-primary text-text-secondary',
  warning:
    'border-border-warning-subtle bg-bg-warning-subtle text-text-warning-subtle',
} as const;

export interface AlertBannerRendererProps {
  variant: 'error' | 'success' | 'info' | 'warning';
  children?: ReactNode;
}

export const AlertBannerRenderer: FC<AlertBannerRendererProps> = ({
  variant,
  children,
}) => (
  <div
    role="alert"
    className={cn(
      'relative flex w-full items-center gap-3 rounded-lg border p-4',
      variantStyles[variant],
    )}
  >
    {children}
  </div>
);
